"use client";
import { jsx as r, jsxs as d } from "react/jsx-runtime";
import p from "classnames";
import { u as w } from "../../../index-C8BMXc19.js";
import { BREAKPOINTS as f } from "../../../constants/breakpoints.js";
import h from "../../heading/Heading.js";
import { r as u } from "../../../index-Cwrov8qI.js";
import y from "../_layout/DialogLayout.js";
import i from "../close/DialogClose.js";
import '../../../assets/Drawer.css';const _ = "_drawer_1ajss_9", m = {
  drawer: _,
  "drawer-header": "_drawer-header_1ajss_42"
}, g = ({ children: e, isOpen: a, onRequestClose: o, title: t, titleAs: n = "h1", titleVariant: c = "h4", className: l }) => {
  const s = w(`(min-width: ${f.tablet}px)`);
  return /* @__PURE__ */ d(y, { isOpen: a, onRequestClose: o, className: p(m.drawer, l), children: [
    /* @__PURE__ */ d("header", { className: m["drawer-header"], children: [
      !s && /* @__PURE__ */ r(i, { icon: "arrowLeft", onClick: o }),
      typeof t == "string" ? /* @__PURE__ */ r(h, { as: n, variant: c, children: t }) : t,
      s && /* @__PURE__ */ r(i, { onClick: o })
    ] }),
    e
  ] });
}, I = ({ customRoot: e, ...a }) => typeof window == "object" ? u.createPortal(/* @__PURE__ */ r(g, { ...a }), e || (document == null ? void 0 : document.getElementById("drawer-portal")) || (document == null ? void 0 : document.body)) : null;
export {
  I as DrawerWrapper,
  I as default
};
